var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_1728)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 27,
    height: 26,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5785C0 1.15425 1.1835 0 2.64375 0H33.3563C34.8165 0 36 1.15425 36 2.5785V33.4215C36 34.8457 34.8165 36 33.3563 36H2.64375C1.1835 36 0 34.8457 0 33.4215V2.5785ZM11.1217 30.1365V13.8802H5.7195V30.1365H11.1217ZM8.42175 11.6595C10.305 11.6595 11.4772 10.413 11.4772 8.8515C11.4435 7.25625 10.3073 6.0435 8.45775 6.0435C6.60825 6.0435 5.4 7.2585 5.4 8.8515C5.4 10.413 6.57225 11.6595 8.38575 11.6595H8.42175ZM19.4648 30.1365V21.0578C19.4648 20.5718 19.5007 20.0857 19.6448 19.7393C20.034 18.7695 20.9228 17.7638 22.4167 17.7638C24.372 17.7638 25.1528 19.2533 25.1528 21.4403V30.1365H30.555V20.8125C30.555 15.8175 27.891 13.4955 24.336 13.4955C21.4695 13.4955 20.1847 15.0705 19.4648 16.1798V16.236H19.4288C19.4407 16.2172 19.4527 16.1985 19.4648 16.1798V13.8802H14.0647C14.1322 15.4058 14.0647 30.1365 14.0647 30.1365H19.4648Z",
    fill: "#0077B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_1728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinNew);
export default __webpack_public_path__ + "static/media/linkedin-new.d371bc2c30c579ea926e4c3e2d803c80.svg";
export { ForwardRef as ReactComponent };